export default __webpack_public_path__ + "static/media/prognos_logotyp_white.739eb910.png";